module.exports = __webpack_public_path__ + "img/first-day-6.ab7892c8.png";